<cigna-omni-messaging-disclaimer
  [isHistory]="isHistoryView"
  [isHistoryLinkEnable]="isHistoryLinkEnable"
  [disclaimer]="disclaimer"
  [shouldEnablePreChatWelcome]="shouldEnablePreChatWelcome"
></cigna-omni-messaging-disclaimer>
<ng-container
  *ngIf="
    !shouldEnablePreChatWelcome ||
    (shouldEnablePreChatWelcome &&
      (isLiveChatAvailable || isHistoryView || conversation?.type !== 'bot'))
  "
>
  <div class="mainCover">
    <ng-container
      *ngFor="
        let message of messages;
        let last = last;
        trackBy: trackByMostRecent
      "
    >
      <cigna-omni-messaging-date-change
        *ngIf="message.firstEventOfDay"
        [date]="message.created"
      ></cigna-omni-messaging-date-change>
      <ng-container [ngSwitch]="message.type">
        <ng-template [ngSwitchCase]="'message'">
          <cigna-omni-messaging-item
            (sendCta)="sendCtaFn($event)"
            (backToPrevious)="backToPrevious()"
            (minibotLinkClick)="minibotLinkClick($event)"
            [props]="message"
            [shouldEnablePreChatWelcome]="shouldEnablePreChatWelcome"
            [shouldEnabledBackToPrevious]="shouldEnabledBackToPrevious"
          ></cigna-omni-messaging-item>
        </ng-template>
        <ng-template [ngSwitchCase]="'wait'">
          <cigna-omni-messaging-wait-time
            [datetime]="message.datetime"
            [footer]="message.footer"
            [lineOne]="message.lineOne"
            [lineTwo]="message.lineTwo"
            [personalGuideEligible]="message.personalGuideEligible"
            [type]="conversationType"
            data-omni-qa="omni-dialog-wait-time"
            [hasEnablePreChatWelcome]="shouldEnablePreChatWelcome"
          ></cigna-omni-messaging-wait-time>
        </ng-template>
        <ng-template [ngSwitchCase]="'participant'">
          <cigna-omni-messaging-system-generated-message
            *ngIf="
              (conversation.uswState !== 'ended' &&
                shouldEnablePreChatWelcome) ||
              isHistoryView
            "
          >
            <cigna-omni-messaging-system-event
              [message]="message.copy"
              [isTransferMessage]="
                conversation.uswState === 'inQueue' &&
                last &&
                message.copy?.includes('transferred')
              "
              [shouldEnablePreChatWelcome]="shouldEnablePreChatWelcome"
              data-omni-qa="omni-dialog-participant-joined"
            ></cigna-omni-messaging-system-event>
          </cigna-omni-messaging-system-generated-message>
        </ng-template>
        <ng-template [ngSwitchCase]="'systemMessage'">
          <cigna-omni-messaging-system-generated-message>
            <cigna-omni-messaging-system-event
              [message]="message.copy"
              data-omni-qa="omni-dm-auto-reply"
            ></cigna-omni-messaging-system-event>
          </cigna-omni-messaging-system-generated-message>
        </ng-template>
      </ng-container>
    </ng-container>
    <p class="typing" *ngIf="!shouldEnablePreChatWelcome && isTyping">
      Agent is typing
    </p>
    <p *ngIf="shouldEnablePreChatWelcome && isTyping" class="typingIndicator">
      Advocate is typing...
    </p>

    <cigna-omni-messaging-outro
      [outro]="outroObj"
      *ngIf="outroObj?.show"
      [isHistory]="isHistoryView"
      [shouldEnablePreChatWelcome]="shouldEnablePreChatWelcome"
      [agentLeftMessageCopy]="agentLeftMessageCopy"
      [isEapUser]="isUseRightNowChat"
    ></cigna-omni-messaging-outro>
  </div>
</ng-container>
<cigna-omni-messaging-after-hours-chat
  *ngIf="
    shouldEnablePreChatWelcome &&
    !isLiveChatAvailable &&
    !isHistoryView &&
    (!conversation || conversation?.type === 'bot')
  "
>
</cigna-omni-messaging-after-hours-chat>
